import type { Cart } from '@miles/domain/Store/Models/Cart/Cart'
import { useRouter } from 'next/router'
import { createContext, FC, PropsWithChildren, useState } from 'react'
import useSWR from 'swr'
import { liveFrontCartService } from 'live/liveBrowserInstances'
import { setInLocalStorage } from 'services/localStorage/getOrSetLocalStorage'
import { KEY_CART_IN_LOCALSTORAGE } from 'store/constants'
export const GET_CART_SWR_KEY = '/medusa/cart'

interface CartContextType {
  cart: Cart | null
  isLoading: boolean
}

export const CartContext = createContext<CartContextType>({
  cart: null,
  isLoading: true
})

export const CartProvider: FC<PropsWithChildren> = ({ children }) => {
  const [cart, setCart] = useState<CartContextType['cart']>(null)
  const router = useRouter()
  const isCheckoutPath =
    (router.pathname.startsWith('/checkout') &&
      !(
        router.pathname.startsWith('/checkout/cart') ||
        router.pathname.startsWith('/checkout/payment') ||
        router.pathname.startsWith('/checkout/success')
      )) ||
    router.pathname.startsWith('/preview')

  const cartDependsPath = useSWR(GET_CART_SWR_KEY, async () => {
    if (
      router.pathname.startsWith('/dashboard') ||
      router.pathname.startsWith('/checkout/payment') ||
      router.pathname.startsWith('/checkout/waiting-room')
    ) {
      // return null
      return liveFrontCartService.dashboardCart()
    } else if (isCheckoutPath) {
      return await liveFrontCartService.checkoutCart()
    } else {
      return await liveFrontCartService.appCart()
    }
  })
  const cartData = cartDependsPath.data

  if (cartData && cart !== cartData) {
    setInLocalStorage(KEY_CART_IN_LOCALSTORAGE, cartData.id)
    setCart(cartData)
  }

  return (
    <CartContext.Provider
      value={{ cart, isLoading: cartDependsPath.isLoading }}
    >
      {children}
    </CartContext.Provider>
  )
}
